export default __webpack_public_path__ + "static/media/logo.eeb6f76f.png";